import React from 'react';

const CaregiverSsnDescription = (
  <>
    <p>
      We recommend providing the caregiver’s Social Security or tax
      identification number in this application.
    </p>
    <p>
      It’s the caregiver’s choice whether they want to provide this information
      in this application. But we’ll need this information in order for them to
      receive certain benefits (like monthly payments or travel, lodging, and
      financial assistance when traveling with the Veteran to receive care).
    </p>
  </>
);

export default CaregiverSsnDescription;
